define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../models/UserContext", "../../models/CPPackageModel"], function (require, exports, $, ko, log, tools, UserContext, CPPackageModel) {
    "use strict";
    var CPPackagesActions = /** @class */ (function () {
        function CPPackagesActions() {
            this.userCanViewCPPackage = ko.observable(UserContext.hasAccess("Admin,CPPackages.View,CPPackages.Edit,CPPackages.Delete"));
            this.userCanEditCPPackage = ko.observable(UserContext.hasAccess("Admin,CPPackages.Edit,CPPackages.Delete"));
            this.userCanDeleteCPPackage = ko.observable(UserContext.hasAccess("Admin,CPPackages.Delete"));
            this.filterByAny = ko.observable();
            this.editModel = ko.observable(new CPPackageModel());
            var self = this;
            if (!self.customerProfileId) {
                self.userCanEditCPPackage(false);
            }
        }
        CPPackagesActions.prototype.getLookupData = function () {
            var self = this;
            return tools.ajaxGet({
                url: "/CPPackages/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.customerUserLookupList = data.Data.lookupLists;
                    }
                }
            });
        };
        CPPackagesActions.prototype.editPackage = function (id) {
            var self = this;
            var title = "Add New Package";
            if (!isNaN(id)) {
                title = "Edit Package";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalClass: "full-width",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Package Name is a required field");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.savePackage(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    var lookupData = null;
                    getModelCall = tools.ajaxGet({
                        url: "/CPPackages/GetCPPackageById",
                        data: { id: id },
                        success: function (result) {
                            if (result.Success) {
                                self.editModel(new CPPackageModel(result.Data));
                            }
                            else {
                                log.error(result.Error);
                            }
                        }
                    });
                    $.when(getModelCall, lookupData).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'cppackage-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        CPPackagesActions.prototype.savePackage = function (btn, modal) {
            var self = this;
            var data = {
                jsonModel: JSON.stringify(tools.modelToFormData(self.editModel()))
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CPPackages/SaveCPPackage",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.afterSuccess) {
                        self.afterSuccess();
                    }
                    $(modal).modal("hide");
                    return;
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CPPackagesActions.prototype.deletePackage = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CPPackages/DeleteCPPackageConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Package deleted successfully");
                    if (self.afterSuccess) {
                        self.afterSuccess();
                    }
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CPPackagesActions.prototype.deletePackageConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Package",
                text: "Are you sure you want to delete package " + name + "?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deletePackage(id);
            });
        };
        return CPPackagesActions;
    }());
    return CPPackagesActions;
});
//# sourceMappingURL=cpPackagesActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customerPortalAdmin/cpPackagesActions.js
// module id = 95
// module chunks = 2